export class WorkflowProcessingNotification {
	public id: string;
	public done: boolean;

	public static fromJson(other: any): WorkflowProcessingNotification {
		const instance = new WorkflowProcessingNotification();
		instance.id = other.Id;
		instance.done = other.Done;
		return instance;
	}
}
